import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-add-transaction',
    templateUrl: './add-transaction.component.html',
    styleUrls: ['./add-transaction.component.scss'],
    standalone: false
})
export class AddTransactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  reset(){
    
  }

}
